import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error,
            errorInfo: null,
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error('React Error Boundary caught an error:', error);
        console.error('Error Info:', errorInfo);
        console.error('Component Stack:', errorInfo.componentStack);
        this.setState({
            error,
            errorInfo,
        });
    }
    render() {
        if (this.state.hasError) {
            return (_jsx("div", { className: "flex min-h-screen items-center justify-center bg-dark-700 p-4", children: _jsxs("div", { className: "w-full max-w-2xl rounded-lg bg-dark-600 p-8 shadow-xl", children: [_jsx("h1", { className: "mb-4 text-2xl font-bold text-error", children: "\u5E94\u7528\u51FA\u9519\u4E86" }), _jsx("p", { className: "mb-4 text-gray-300", children: "\u62B1\u6B49\uFF0C\u5E94\u7528\u9047\u5230\u4E86\u4E00\u4E2A\u9519\u8BEF\u3002\u8BF7\u5237\u65B0\u9875\u9762\u91CD\u8BD5\u3002" }), _jsxs("details", { className: "mb-4", children: [_jsx("summary", { className: "cursor-pointer text-sm text-gray-400 hover:text-gray-300", children: "\u67E5\u770B\u9519\u8BEF\u8BE6\u60C5" }), _jsxs("div", { className: "mt-2 rounded bg-dark-700 p-4", children: [_jsx("p", { className: "mb-2 font-mono text-sm text-error", children: this.state.error?.toString() }), this.state.errorInfo && (_jsx("pre", { className: "overflow-auto text-xs text-gray-400", children: this.state.errorInfo.componentStack }))] })] }), _jsx("button", { onClick: () => window.location.reload(), className: "rounded-lg bg-primary-500 px-6 py-2 text-white transition-colors hover:bg-primary-600", children: "\u5237\u65B0\u9875\u9762" })] }) }));
        }
        return this.props.children;
    }
}
